const initialState = {};

const prizeReducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    default:
      return state;
  }
};

export default prizeReducer;
